export const createGridContainer = (gridLayoutGap, gridColumnCount, gridItemMinWidth) => `
  --gap-count: calc(${gridColumnCount} - 1);
  --total-gap-width: calc(var(--gap-count) * ${gridLayoutGap});
  --grid-item--max-width: calc((100% - var(--total-gap-width)) / ${gridColumnCount});

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(max(${gridItemMinWidth}, var(--grid-item--max-width)), 1fr));
  grid-gap: ${gridLayoutGap};
`;